import axios from '@/axios';

export default {
    /**
   * Подать заявку на апеляцию
   *
   * @param {Object} vuex
   * @param {Object} vuex.state
   * @param {Function} vuex.commit
   * @param {Number} index - Индекс лида
   * @return {Promise}
   */
    appealRequest({ state, commit }, index) {
        return new Promise((resolve, reject) => {
            const { id } = state.data[index];

            axios.post('cabinet/requests/appeal', {
                id,
            })
                .then(({ data: { data: { request: data } } }) => {
                    commit('SET_LEAD', { data, index });
                    resolve(data);
                })
                .catch((error) => { reject(error); });
        });
    },

    /**
   * Снять  апеляций
   *
   * @param {Object} vuex
   * @param {Object} vuex.state
   * @param {Function} vuex.commit
   * @param {Number} index - Индекс лида
   *
   * @return {Promise}
   */
    declineAppealRequest({ state, commit }, index) {
        return new Promise((resolve, reject) => {
            const { id } = state.data[index];

            axios.post('cabinet/requests/decline', {
                id,
            })
                .then(({ data: { data: { request: data } } }) => {
                    commit('SET_LEAD', { data, index });
                    resolve(data);
                })
                .catch((error) => { reject(error); });
        });
    },

    /**
   * Получить лиды из Backend и запичать в store
   *
   * @param {Object} vuex
   * @param {Function} vuex.commit
   * @param {Object} params - параметры
   *
   * @return {Promise}
   */
    fetchLeads({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get('cabinet/requests/all', {
                params,
            })
                .then(({ data: { data } }) => {
                    commit('SET_LEADS', { data: data.list });
                    commit('UPDATE_TOTAL_COUNT', data.total);
                    commit('SET_GRAPH', data.graph);
                    resolve(data);
                })
                .catch((error) => {
                    commit('SET_LEADS', { data: [] });
                    reject(error);
                });
        });
    },

    /**
   * Обновляем комментарий
   *
   * @param {Object} vuex
   * @param {Object} vuex.state
   * @param {Function} vuex.commit
   * @param {Object} payload
   * @param {Number} payload.index - Индекс лида
   * @param {String} payload.newComment - Новое комментарий
   *
   * @return {Promise}
   */
    updateComment({ state, commit }, { index, newComment }) {
        return new Promise((resolve, reject) => {
            const { id } = state.data[index];

            axios.put('cabinet/requests/addComment', {
                comment: newComment,
                id,
            })
                .then(({ data: { data } }) => {
                    commit('UPDATE_COMMENT', { index, newComment });
                    resolve(data);
                })
                .catch((error) => { reject(error); });
        });
    },
};
